
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import logoHandBtn from '../assets/logo_hand_button.png';

interface Props {
  onLoginSuccess: (credential: string) => void | Promise<void>;
  errorMessage?: string;
}

const LoginPage: React.FC<Props> = ({ onLoginSuccess, errorMessage = '' }) => {
  return (
    <div className="praxys-login-shell">
      <div className="praxys-login-corner-logo">
        <img src={logoHandBtn} alt="Praxys" className="praxys-login-corner-img" />
      </div>

      <div className="praxys-login-center">
        <div className="praxys-login-card">
          {/* Brand block */}
          <div className="praxys-login-brand-wrap">
            <img src={logoHandBtn} alt="Praxys" className="praxys-login-brand-img" />
            <div className="praxys-login-brand-name">Praxys</div>
            <div className="praxys-login-tagline">makes better</div>
          </div>

          <div className="praxys-login-divider" />

          <div className="praxys-login-google-wrap">
            <GoogleLogin
              onSuccess={(res) => {
                if (res.credential) onLoginSuccess(res.credential);
              }}
              onError={() => {
                console.error('Google sign-in failed');
              }}
              useOneTap={false}
              theme="filled_black"
              size="large"
              shape="rectangular"
              text="signin_with"
              width="280"
            />
          </div>

          <p className="praxys-login-disclaimer">
            Sign in or create an account to continue
          </p>
          {errorMessage && (
            <div className="praxys-login-beta-error">
              {errorMessage}
            </div>
          )}
        </div>
      </div>

      <footer className="praxys-login-footer">
        <a
          href="/terms"
          className="praxys-login-footer-link"
        >
          Terms of Service
        </a>
        <span className="praxys-login-footer-sep">·</span>
        <a
          href="/privacy"
          className="praxys-login-footer-link"
        >
          Privacy Policy
        </a>
        <span className="praxys-login-footer-sep">·</span>
        <span className="praxys-login-footer-copy">©2026 Felfi</span>
      </footer>
    </div>
  );
};

export default LoginPage;
